// @flow
import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import { mediaMax } from 'frontend_core/dist/styles/media'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imagePath } from 'frontend_core/dist/helpers/image'

const Wrapper = styled.div`
  margin-left: 50px;

  &::after {
    display: block;
    clear: both;
    content: '';
  }
  ${mediaMax.phone`
    margin-left: 0;
  `};
`

const Container = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
`

const StatusWrapper = styled.div`
  display: inline-block;
  padding-right: ${spacing.small_2}px;
  vertical-align: bottom;
`

const Status = styled.span`
  display: block;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
  text-align: right;
  line-height: 1.5;
`

const MessageWrapper = styled.div`
  display: table-cell;
  padding: ${spacing.small_2}px 0 ${spacing.small_2}px ${spacing.small_2}px;
`

const Message = styled.div`
  display: inline-block;
  max-width: calc(100% - 40px);
  padding: ${spacing.medium}px;
  border-radius: 16px;
  border-bottom-right-radius: ${borderRadius}px;
  background-color: ${Colors.subBgColor};
  font-size: ${fontSize.small_3}px;
`

const MessageText = styled.p`
  vertical-align: bottom;
  line-height: 1.7;
  white-space: pre-wrap;
`

const ImageContainer = styled.div`
  display: table;
  margin-top: ${spacing.medium}px;
  padding-top: ${spacing.medium}px;
  width: 100%;
  border-top: 1px dashed ${Colors.grayE};
`

const ImageWrapper = styled.div`
  position: relative;
  display: table-cell;
  width: 40px;
  height: 40px;
  border-radius: ${borderRadius}px;
  overflow: hidden;
`

const ThumbnailTitle = styled.div`
  display: table-cell;
  padding-left: ${spacing.medium}px;
  color: ${Colors.blue};
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  vertical-align: middle;
`

const Attachment = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${Colors.white};
  ${({ imageUrl }) => `
    background-image: url('${imageUrl}');
  `} background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
`

type PropTypes = {
  time?: string,
  messageText: string,
  read: boolean,
  isAttachment?: boolean,
  thumbnailUrl: string,
  src: string,
  alt: string,
  filename: string,
}

export default (props: PropTypes) => (
  <Wrapper>
    <Container>
      <MessageWrapper>
        <StatusWrapper>
          <Status>
            {props.read ? i18n.t('page.dashboard.reservation.alreadyRead') : ''}
            <br />
            {props.time}
          </Status>
        </StatusWrapper>
        <Message>
          <MessageText
            dangerouslySetInnerHTML={{ __html: props.messageText }}
          />
          <ImageContainer>
            <a href={props.thumbnailUrl} target="_blank">
              <ImageWrapper>
                {props.isAttachment ? (
                  <Attachment imageUrl={imagePath('common/file.svg')} />
                ) : (
                  <OptimizedImage
                    src={props.src}
                    alt={props.alt}
                    type="responsive"
                  />
                )}
              </ImageWrapper>
              <ThumbnailTitle>{props.filename}</ThumbnailTitle>
            </a>
          </ImageContainer>
        </Message>
      </MessageWrapper>
    </Container>
  </Wrapper>
)



// WEBPACK FOOTER //
// ./src/components/molecules/message/MessageWithAttachmentSelf/index.jsx